import React, { useEffect, useState } from 'react';
import { X, BadgePercent, ArrowRight, Sparkles } from 'lucide-react';

const STORAGE_KEY = 'hh_promo_seen_v1';

export default function PromoPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const t = setTimeout(() => setOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="promo-title" data-testid="promo-popup">
      <div className="absolute inset-0 bg-[#050E24]/70 backdrop-blur-sm promo-fade" onClick={close} aria-hidden />
      <div className="relative w-full max-w-md rounded-3xl overflow-hidden shadow-[0_40px_100px_rgba(0,0,0,0.6)] promo-pop">
        <div className="bg-[#0B1E44] text-white p-7 md:p-8 relative overflow-hidden">
          <div className="absolute inset-0 dotted-bg opacity-15" aria-hidden />
          <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#DC2626]/30 blur-3xl" aria-hidden />
          <button onClick={close} className="absolute z-10 top-4 right-4 w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" aria-label="Schließen" data-testid="promo-close">
            <X className="w-4 h-4" />
          </button>
          <div className="relative">
            <span className="inline-flex items-center gap-1.5 bg-[#DC2626] text-white text-[11px] font-extrabold uppercase tracking-wider px-3 py-1 rounded-full">
              <Sparkles className="w-3 h-3" /> Nur für Neukunden
            </span>
            <div className="mt-5 flex items-end gap-3">
              <div className="text-7xl md:text-8xl font-extrabold leading-none gold-text">30%</div>
              <div className="pb-2 text-white/90 font-bold text-lg md:text-xl leading-tight">Neukunden-<br />Rabatt</div>
            </div>
            <h2 id="promo-title" className="mt-5 text-base md:text-lg font-bold">Willkommen bei den Haushelden!</h2>
            <p className="mt-2 text-white/75 text-sm leading-relaxed">
              Sichern Sie sich als Neukunde 30&nbsp;% Rabatt auf Ihren ersten Auftrag – egal ob Steinreinigung, Fassade, Dach oder Garten.
              Einfach anfragen und den Code nennen.
            </p>
            <div className="mt-4 inline-flex items-center gap-2 bg-white/10 border border-dashed border-[#E0A72C]/70 rounded-lg px-4 py-2.5">
              <BadgePercent className="w-4 h-4 text-[#E8B547]" />
              <span className="text-xs text-white/70">Ihr Code:</span>
              <span className="font-mono font-extrabold tracking-widest text-[#E8B547]" data-testid="promo-code">NEUKUNDE30</span>
            </div>
          </div>
        </div>
        <div className="bg-white p-5 flex flex-col sm:flex-row gap-3">
          <a href="/#kontakt" onClick={() => { localStorage.setItem('hh_promo_code', 'NEUKUNDE30'); window.dispatchEvent(new CustomEvent('hh-promo-code', { detail: 'NEUKUNDE30' })); close(); }} className="btn-gold flex-1 inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-md text-[15px] font-semibold" data-testid="promo-cta">
            Jetzt Rabatt sichern <ArrowRight className="w-4 h-4" />
          </a>
          <button onClick={close} className="px-5 py-3.5 rounded-md text-sm text-slate-500 hover:text-[#0B1E44] transition-colors" data-testid="promo-dismiss">
            Später
          </button>
        </div>
      </div>
    </div>
  );
}
